import { tabelaRegularizacaoEfetivacaoStyles } from './TabelaRegularizacaoEfetivacao.styles'

export function tabelaRegularizacaoEfetivacaoIO() {
  return {
    styles: tabelaRegularizacaoEfetivacaoStyles
  }
}

export type TabelaRegularizacaoEfetivacaoIO = ReturnType<typeof tabelaRegularizacaoEfetivacaoIO>
